'use client'

import React from 'react'
import { DashboardLayout } from '@/components/dashboard/DashboardLayout'

const page = () => {
  return (
    <div>
      <DashboardLayout />
    </div>
  )
}

export default page